export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20light%20streaks%2C%20abstract%20film%20reel%20texture%2C%20soft%20dramatic%20lighting%2C%20luxurious%20velvet%20curtain%20texture%2C%20elegant%20wide%20angle%2C%20professional%20cinematography%20aesthetic%2C%20high%20contrast%2C%20warm%20tones%20with%20deep%20shadows%2C%20no%20text%20or%20logos&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="西瓜影视影院氛围背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0 z-10">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs md:text-sm font-medium border border-accent-500/30 mb-5 whitespace-nowrap">
              蓝光画质 · 流畅播放
            </span>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-3">
              西瓜影视
              <span className="block text-xl md:text-2xl lg:text-3xl font-bold text-background-200 mt-2">
                高清不缓冲在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg font-heading text-accent-400 font-semibold mb-6">
              海量影视，即刻畅享
            </p>

            <div className="text-sm md:text-base text-background-300 leading-relaxed space-y-3 mb-8 max-w-xl lg:max-w-none mx-auto lg:mx-0">
              <p>
                西瓜影视汇聚全网热门电影、电视剧、综艺、动漫及纪录片资源，覆盖动作、喜剧、悬疑、科幻等多元题材，每日同步更新最新片源。
              </p>
              <p>
                依托先进的智能CDN加速与自适应码率技术，无论您是通勤路上用手机追剧，还是在家用大屏享受蓝光画质，都能获得流畅不缓冲的极致观影体验。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10万+</p>
                <p className="text-xs md:text-sm text-background-400 mt-1">影视资源</p>
              </div>
              <div className="w-px h-10 bg-background-500/40 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">4K蓝光</p>
                <p className="text-xs md:text-sm text-background-400 mt-1">超清画质</p>
              </div>
              <div className="w-px h-10 bg-background-500/40 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">7×24</p>
                <p className="text-xs md:text-sm text-background-400 mt-1">持续更新</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 text-background-100 font-medium text-sm rounded-lg border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20collage%20composition%2C%20warm%20golden%20and%20crimson%20accents%2C%20abstract%20movie%20elements%2C%20dramatic%20lighting%2C%20film%20strip%20and%20projector%20lens%20motifs%2C%20luxurious%20cinema%20aesthetic%2C%20high%20contrast%2C%20professional%20design%2C%20no%20text%20or%20logos&width=800&height=1000&seq=hero-visual-2026&orientation=portrait"
                  alt="西瓜影视主视觉 - 高清电影电视剧在线观看"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-2xl bg-primary-500/90 flex items-center justify-center">
                <div className="text-center text-background-50">
                  <i className="ri-fire-line text-2xl"></i>
                  <p className="text-xs font-bold mt-1 whitespace-nowrap">热播中</p>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 w-20 h-20 rounded-full bg-accent-500/90 flex items-center justify-center">
                <div className="text-center text-background-950">
                  <i className="ri-vip-crown-line text-xl"></i>
                  <p className="text-xs font-bold mt-0.5 whitespace-nowrap">蓝光</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}